import { ITalkerProps } from '@/entities/Talker'
import { IQueryProps } from '@/entities/Query'

export const Types = {
  store: 'store',
  fetched: 'fetched',
  udpate: 'udpate',
  query: 'query',
  loading: 'loading',
  current: 'current',
  reset: 'reset',
  clear: 'clear'
}

export const path = 'talker/'

export class Store implements FluxStandardAction<ITalkerProps[]> {
  type = path + Types.store
  constructor(public payload: ITalkerProps[]) {}
}

export class Fetched implements FluxStandardAction<ITalkerProps[]> {
  type = path + Types.fetched
  constructor(public payload: ITalkerProps[]) {}
}

export class Update implements FluxStandardAction<ITalkerProps> {
  type = path + Types.udpate
  constructor(public payload: ITalkerProps) {}
}

export class Query implements FluxStandardAction<IQueryProps> {
  type = path + Types.query
  constructor(public payload: IQueryProps) {}
}

export class Loading implements FluxStandardAction<boolean> {
  type = path + Types.loading
  constructor(public payload: boolean) {}
}

export class Current implements FluxStandardAction<ITalkerProps> {
  type = path + Types.current
  constructor(public payload: ITalkerProps) {}
}

export class Reset implements FluxStandardAction<boolean> {
  type = path + Types.reset
  constructor(public payload: boolean) {}
}

export class Clear implements FluxStandardAction<void> {
  type = path + Types.clear
  constructor() {}
}
